import { Facility } from "./facility";
import { ConversationCount } from "./conversationcount";
import { TimeSlotSchedule } from "./timeslot";
import { CompanyReferralIncentive } from "../referrals/companyReferralIncentive";

export class Job {
  public candidatePlacementTypeText = "";
  public candidatePlacementTypeValue = "";
  public jobPostingId: number = 0;
  public jobPostingName: string = "";
  public jobPostingType: string = "";
  public startDTTM: number = 0;
  public endDTTM: any;
  public jobPublishDTTM: number = 0;
  public jobPayRateLow: number = 0;
  public jobPayRateHigh: number = 0;
  public jobPayUOM: string = "";
  public payRateNegotiable: boolean = false;
  public startImmediately: boolean = true;
  public remainingPositions: number = 0;
  public timeslotsCount: number = 0;
  public recurrence: any;
  public timeSlot: any;
  public companyCode: string = "";
  public companyName: string = "";
  public comment:string = '';
  public reasonCodeId:number=-1;
  public companyLogo: boolean = false;
  public logoLastModified: number = 0;
  public step:number=0;
  public jobPostingAssignmentStatus:number=0;
  public facility: Facility = new Facility();
  public distance: number = 0;
  public savedDTTM: any;
  public jobPostingRefNbr: any;
  public jobPostingDescription: any;
  public jobPostingVideoURL: any;
  public timeSlotSchedules: TimeSlotSchedule[] = [];
  public jobSkills: string[] = [];
  public conversationCount: ConversationCount = new ConversationCount();
  public createdByUserId: number = 0;
  public facilityName: any;
  public jobReferralSubject: any;
  public jobReferralMessage: any;
  public llamaJobReferralSubject: any;
  public llamaJobReferralMessage: any;
  public hiredDate: any;
  public userLockIn: any;
  public externalJobUrl: any;
  public resumeRequired: boolean = false;
  public localPresenceNeeded: any;
  public facilityPremisesNotifyDistance: number = 0;
  public companyReferralIncentive: CompanyReferralIncentive = new CompanyReferralIncentive();
  public jobPriority: any;
  public hasAppliedJob: any;
  public bookmarkStatus: any;
  public shiftTypeValue: string = "";
  public numberOfShifts: any;
  public hoursPerDay: any;
  public jobPostingCustomData: any;
  public resumeUploadRequired: string = "";
  public jobPostingStatus:string="";
}
